import type { OrgProfile } from '@/libs/interfaces'

import { MOCK_ORG_ID } from '../fixtures/seed'
import { delay } from '../helpers'

const mockOrgProfile: OrgProfile = {
  orgID: MOCK_ORG_ID,
  orgName: 'Care of Cars Demo AB',
  orgNumber: '556677-8899',
  orgAddress: 'Testgatan 1',
  orgZipCode: '111 22',
  orgCity: 'Stockholm',
  orgCountry: 'Sweden',
  orgPhone: '+46 8 123 456',
  orgEmail: 'info@careofcars.example',
  orgWebsite: 'https://careofcars.example',
}

export const orgApiMock = {
  getProfile: async (_orgID: string): Promise<OrgProfile> => delay(mockOrgProfile),
}
